import { render, staticRenderFns } from "./sous_menu.vue?vue&type=template&id=c3423d9e"
import script from "./sous_menu.js?vue&type=script&lang=js&external"
export * from "./sous_menu.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports